import React from 'react';
import type { Theme } from 'baseui';
import { useStyletron } from 'baseui';
import { MonoLabelXSmall } from 'baseui/typography';
import { getColumnHeaderHeight, ROW_HEADER_WIDTH, ROW_HEADER_Z_INDEX } from './constants';
type PropsT = {
  hasAnnotations: boolean;
};
const containerCss = (theme: Theme) => ({
  position: ('absolute' as const),
  top: '0px',
  left: '0px',
  height: getColumnHeaderHeight(theme),
  width: `${ROW_HEADER_WIDTH}px`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  boxSizing: ('border-box' as const),
  backgroundColor: theme.colors.backgroundPrimary,
  zIndex: ROW_HEADER_Z_INDEX,
  borderRight: `1px solid ${theme.colors.borderOpaque}`,
  borderBottom: `1px solid ${theme.colors.borderOpaque}`
});
export function ObjectsLabel({
  hasAnnotations
}: PropsT) {
  const [css, theme] = useStyletron();
  return <div className={css(containerCss(theme))}>
      {hasAnnotations ? <MonoLabelXSmall color={theme.colors.contentInverseTertiary}>Objects</MonoLabelXSmall> : null}
    </div>;
}